import styled from "styled-components";

const CircleAvatar = styled.img`
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
`;

export default CircleAvatar